import { Component, OnInit } from '@angular/core';
import { MasterBlogComponent } from '../../blog/master-blog/master-blog.component';
import { NEWS } from '../../../mokup/news';

@Component({
  selector: 'app-service-blog',
  templateUrl: './service-blog.component.html',
})
export class ServiceBlogComponent extends MasterBlogComponent {
  masterList = []
 
  ngOnInit(){
 
     super.ngOnInit()
     this.init()
   }
     async init(){
 
     
   }
  

}



// WEBPACK FOOTER //
// ./src/app/components/blog/service-blog/service-blog.component.ts